import StandardLayout from '../views/StandardLayout.vue'
import ParametersLayout from '../views/ParametersLayout.vue'

/* const mustBeAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    return next()
  }
  next('/login')
} */

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { noguard: true }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPassword.vue'),
    meta: { noguard: true }
  },
  {
    path: '/',
    component: StandardLayout,
    children: [
      {
        path: 'photo',
        component: () => import('../views/Photo.vue'),
        meta: {
          toolbar: {
            title: 'photo.title'
          }
        }
      },
      {
        path: 'dashboard',
        component: () => import('../views/DashBoard.vue'),
        meta: {
          toolbar: {
            title: 'dashboard.title'
          }
        }
      },
      {
        path: 'logs-error',
        component: () => import('../views/Log.vue'),
        meta: {
          toolbar: {
            title: 'Logs Import / Export'
          }
        }
      },
      {
        path: 'parameters',
        component: ParametersLayout,
        children: [
          {
            path: 'users',
            component: () => import('../views/User.vue'),
            meta: {
              toolbar: {
                title: 'parameters.title'
              }
            }
          },
          {
            path: 'profile',
            component: () => import('../views/UserProfile.vue'),
            meta: {
              toolbar: {
                title: 'parameters.title'
              }
              /* saveOnQuit: {
                title: 'dialog.user.update.title',
                content: 'dialog.user.update.content'
              } */
            }
          },
          {
            path: 'groupability',
            component: () => import('../views/Roles.vue'),
            meta: {
              toolbar: {
                title: 'parameters.title'
              }
            }
          },
          /* {
            path: 'photo',
            component: () => import('../views/Photo.vue'),
            meta: {
              toolbar: {
                title: 'photo.title'
              }
            }
          }, */
          {
            path: 'syncprestanode',
            component: () => import('../views/SyncPrestaNode.vue'),
            meta: {
              toolbar: {
                title: 'parameters.title'
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }]
